import { Button } from 'antd'
import StatusCell from '../../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../../elements/Table/CustomTable'
import { get, round } from 'lodash'
import React from 'react'
import { Link } from 'react-router-dom'

function CargoLinesList(props) {
  const { list, isUpdatable, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'Package',
      accessor: 'package.code',
      Cell: ({ value, original }) => (
        <Link
          target={'_blank'}
          to={{
            pathname: `/purchasing/${original.package._id}/update`,
          }}>
          {value}
        </Link>
      ),
      width: 175,
    },
    {
      Header: 'ID',
      accessor: '_key',
      width: 175,
      hideable: true,
      hideDefault: true,
    },
    { Header: 'D.O Code', accessor: 'package.deliveryOrder.code', width: 175 },
    { Header: 'Description', accessor: 'package.name' },
    { Header: 'Units', accessor: 'package.unit', width: 100 },
    {
      Header: 'Weight (Net)',
      accessor: 'package.shipping.weights.net',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'package.shipping.weights.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Weight (Gross)',
      accessor: 'package.shipping.weights.gross',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'package.shipping.weights.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Length',
      accessor: 'package.shipping.dimensions.length',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'package.shipping.dimensions.scale.code')}
        </span>
      ),
    },
    {
      Header: 'width',
      accessor: 'package.shipping.dimensions.width',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'package.shipping.dimensions.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Height',
      accessor: 'package.shipping.dimensions.height',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'package.shipping.dimensions.scale.code')}
        </span>
      ),
    },
    {
      Header: 'Volume',
      accessor: 'package.shipping.volume.volume',
      width: 100,
      Cell: ({ original, value }) => (
        <span>
          {round(value, 3)} {get(original, 'package.shipping.volume.scale.code')}
        </span>
      ),
    },
    { Header: 'Status', accessor: 'package.status', Cell: StatusCell },
  ]

  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow} disabled={!isUpdatable}>
          New Cargo
        </Button>
      )}
      columns={columns}
    />
  )
}

CargoLinesList.propTypes = {}
CargoLinesList.defaultProps = {}

export default CargoLinesList
